"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var ColumnView = /** @class */ (function () {
    function ColumnView(element, isNew, isCreated, defaultNewBtn) {
        this._drowDownShow = false;
        this._element = element;
        this._children = [];
        this._calculatedBranchIndexesAfterOrBeforeChange = new Map();
        this.isNew = isNew;
        this.isCreated = isCreated;
        this.isDefaultNew = defaultNewBtn;
        if (this._element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
            this._columnStyleDto = new idm_report_export_service_client_js_1.ColumnCategoryStyleDto();
        }
        else if (this._element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
            this._columnStyleDto = new idm_report_export_service_client_js_1.ColumnMeasureStyleDto();
        }
        else {
            this._columnStyleDto = new idm_report_export_service_client_js_1.ReportElementStyleDto();
        }
    }
    Object.defineProperty(ColumnView.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        set: function (value) {
            this._parent = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "children", {
        get: function () {
            return this._children;
        },
        set: function (value) {
            this._children = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "index", {
        get: function () {
            return this._index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "element", {
        get: function () {
            return this._element;
        },
        set: function (value) {
            this._element = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isActive", {
        get: function () {
            return this._isActive;
        },
        set: function (value) {
            this._isActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isSelected", {
        get: function () {
            return this._isSelected;
        },
        set: function (value) {
            this._isSelected = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isHighlighted", {
        get: function () {
            return this._isHighlighted;
        },
        set: function (value) {
            this._isHighlighted = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isDefaultNew", {
        get: function () {
            return this._isDefaultNew;
        },
        set: function (value) {
            this._isDefaultNew = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isDefaultNewWide", {
        get: function () {
            return this._isDefaultNewWide;
        },
        set: function (value) {
            this._isDefaultNewWide = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isNew", {
        get: function () {
            return this._isNew;
        },
        set: function (value) {
            this._isNew = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isAnimationDisabled", {
        get: function () {
            return this._isAnimationDisabled;
        },
        set: function (value) {
            this._isAnimationDisabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isDragEntered", {
        get: function () {
            return this._isDragEntered;
        },
        set: function (value) {
            this._isDragEntered = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isDragging", {
        get: function () {
            return this._isDragging;
        },
        set: function (value) {
            this._isDragging = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isRemoved", {
        get: function () {
            return this._isRemoved;
        },
        set: function (value) {
            this._isRemoved = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isGoingToRemove", {
        get: function () {
            return this._isGoingToRemove;
        },
        set: function (value) {
            this._isGoingToRemove = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isParentRemoved", {
        get: function () {
            return this._isParentRemoved;
        },
        set: function (value) {
            this._isParentRemoved = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isBeforeNew", {
        get: function () {
            return this._isBeforeNew;
        },
        set: function (value) {
            this._isBeforeNew = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isCreated", {
        get: function () {
            return this._isCreated;
        },
        set: function (value) {
            this._isCreated = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isBeforeCreated", {
        get: function () {
            return this._isBeforeCreated;
        },
        set: function (value) {
            this._isBeforeCreated = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "columnStyleDto", {
        get: function () {
            return this._columnStyleDto;
        },
        set: function (value) {
            this._columnStyleDto = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "isGoingToReplace", {
        get: function () {
            return this._isGoingToReplace;
        },
        set: function (value) {
            this._isGoingToReplace = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnView.prototype, "drowDownShow", {
        get: function () {
            return this._drowDownShow;
        },
        set: function (value) {
            this._drowDownShow = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Add specified node as child node of current node
     * @param {ColumnView} item Specified tree node
     * @returns {ColumnView} Current tree node.
     */
    ColumnView.prototype.add = function (item) {
        item._parent = this;
        item._index = this._children.length;
        this._children.push(item);
        return this;
    };
    /**
     * Add specified node as child node of current node in specified index
     * @param {ColumnView} item Specified tree node.
     * @param {number} index Index in which node must be added
     * @returns {ColumnView} Return current tree node.
     */
    ColumnView.prototype.addWithIndex = function (item, index) {
        item._parent = this;
        item._index = index;
        var children = [];
        for (var i = 0; i < index; i++) {
            children.push(this._children[i]);
        }
        children.push(item);
        for (var i = index; i < this._children.length; i++) {
            children.push(this._children[i]);
        }
        this._children = children;
        return this;
    };
    /**
     * Pop sub tree of node with specified index.
     * @param {number} index    Index of node which subtree must be popped up.
     * @returns {ColumnView}    Popped sub-tree.
     */
    ColumnView.prototype.popTreeWithIndex = function (index) {
        var children = [];
        var element = this._children[index];
        for (var i = 0; i < index; i++) {
            children.push(this._children[i]);
        }
        for (var i = index + 1; i < this.children.length; i++) {
            children.push(this._children[i]);
        }
        this._children = children;
        return element;
    };
    /**
     * Pop node with specified index.
     * @param {number} index    Index of node which must be popped up.
     * @returns {ColumnView}    Popped node.
     */
    ColumnView.prototype.popNodeWithIndex = function (index) {
        var children = [];
        var element = this._children[index];
        for (var i = 0; i < index; i++) {
            children.push(this._children[i]);
        }
        for (var i = 0; i < element.children.length; i++) {
            var node = element.children[i];
            node.parent = this;
            children.push(node);
        }
        for (var i = index + 1; i < this.children.length; i++) {
            children.push(this._children[i]);
        }
        this._children = children;
        element.children = [];
        return element;
    };
    /**
     * Recalculate tree indexes. Each node has index equals to index of node in parent's children array.
     */
    ColumnView.prototype.recalculateIndexes = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i]._index = i;
            this._children[i].recalculateIndexes();
        }
    };
    /**
     * Remove temporary nodes (nodes with flag is-new) from tree.
     */
    ColumnView.prototype.removeTemporaryNodes = function () {
        var children = [];
        for (var i = 0; i < this._children.length; i++) {
            if (!this._children[i].isNew) {
                this._children[i].isBeforeNew = false;
                this._children[i].removeTemporaryNodes();
                children.push(this._children[i]);
            }
            this._children[i].isDefaultNewWide = false;
            this._children[i].isAnimationDisabled = false;
        }
        this._children = children;
    };
    /**
     * Remove removed nodes (nodes with flag is-removed) from tree.
     */
    ColumnView.prototype.cleanRemovedNodes = function () {
        var finished = false;
        while (!finished) {
            finished = true;
            for (var i = 0; i < this._children.length; i++) {
                this._children[i].cleanRemovedNodes();
                if (this._children[i].isRemoved) {
                    finished = false;
                    var index = this._children[i].index;
                    var parent_1 = this._children[i].parent;
                    parent_1.popNodeWithIndex(index);
                    parent_1.recalculateIndexes();
                    break;
                }
            }
        }
    };
    /**
     * Check whether tree has isActive node (node with flag isActive ) or not.
     * @returns {boolean} True when tree has isActive node, otherwise return false.
     */
    ColumnView.prototype.hasActiveNode = function () {
        if (this._isActive) {
            return true;
        }
        else {
            for (var i = 0; i < this._children.length; i++) {
                if (this._children[i].hasActiveNode()) {
                    return true;
                }
            }
            return false;
        }
    };
    /**
     * Get selected node (node with flag is-selected) of tree.
     * @returns {ColumnView}    Selected node os tree.
     */
    ColumnView.prototype.getSelectedNode = function () {
        if (this._isSelected) {
            return this;
        }
        else {
            for (var i = 0; i < this._children.length; i++) {
                var selectedNode = this._children[i].getSelectedNode();
                if (selectedNode) {
                    return selectedNode;
                }
            }
            return null;
        }
    };
    /**
     * Set is-before-created flags on nodes.
     * After creating node, nodes with before-new flags becode before-created,
     * that is why we set before-created flag true on nodes with before-new flag, otherwise set false.
     */
    ColumnView.prototype.setBeforeCreatedFlags = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].isBeforeCreated = this._children[i].isBeforeNew;
            this._children[i].setBeforeCreatedFlags();
        }
    };
    /**
     * Set is-removed flag on sub-tree.
     */
    ColumnView.prototype.setRemovedFlagOnChildren = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].isRemoved = true;
            this._children[i].setRemovedFlagOnChildren();
        }
    };
    /**
     * Set is-going-to-remove flag on sub-tree.
     */
    ColumnView.prototype.setGoingToRemoveFlags = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].isGoingToRemove = true;
            this._children[i].setGoingToRemoveFlags();
        }
    };
    /**
     * Clean flags, remove temporary/removed nodes and recalculate indexes of tree nodes.
     */
    ColumnView.prototype.clean = function () {
        this.cleanGoingToReplaceFlags();
        this.cleanGoingToRemoveFlags();
        this.cleanRemovedNodes();
        this.cleanSelectedFlags();
        this.cleanCreatedFlags();
        this.cleanActiveFlags();
        this.cleanParentRemovedFlags();
        this.cleanHighlightedFlags();
        this.removeTemporaryNodes();
        this.recalculateIndexes();
    };
    /**
     * Clean is-created and is-before-created flags from tree nodes.
     */
    ColumnView.prototype.cleanCreatedFlags = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].isBeforeCreated = false;
            this._children[i].isCreated = false;
            this._children[i].cleanCreatedFlags();
        }
    };
    /**
     * Clean is-active flag from tree nodes.
     */
    ColumnView.prototype.cleanActiveFlags = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].isActive = false;
            this._children[i].cleanActiveFlags();
        }
    };
    /**
     * Clean is-selected flag from tree nodes.
     */
    ColumnView.prototype.cleanSelectedFlags = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i]._isSelected = false;
            this._children[i].cleanSelectedFlags();
        }
    };
    /**
     * Clean is-highlighted flag from tree nodes.
     */
    ColumnView.prototype.cleanHighlightedFlags = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].isHighlighted = false;
            this._children[i].cleanHighlightedFlags();
        }
    };
    /**
     * Clean is-drag-entered flag from tree nodes.
     */
    ColumnView.prototype.cleanDragEnteredFlags = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].isDragEntered = false;
            this._children[i].cleanDragEnteredFlags();
        }
    };
    /**
     * Clean is-drag-entered and is-dragging flags from tree nodes.
     */
    ColumnView.prototype.cleanDragFlags = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].isDragEntered = false;
            this._children[i].isDragging = false;
            this._children[i].cleanDragFlags();
        }
    };
    /**
     * Clean animated flags (flags which produce animation on UI) from tree nodes.
     */
    ColumnView.prototype.cleanAnimatedFlags = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].isAnimationDisabled = (this._children[i].isNew || this._children[i].isBeforeNew || this._children[i].isDefaultNewWide);
            this._children[i].isBeforeCreated = false;
            this._children[i].isCreated = false;
            this._children[i].isHighlighted = false;
            this._children[i].isParentRemoved = false;
            this._children[i].cleanAnimatedFlags();
        }
    };
    /**
     * Clean is-parent-removed flag from tree nodes.
     */
    ColumnView.prototype.cleanParentRemovedFlags = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].isParentRemoved = false;
            this._children[i].cleanParentRemovedFlags();
        }
    };
    /**
     * Clean is-going-to-remove flags from tree nodes.
     */
    ColumnView.prototype.cleanGoingToRemoveFlags = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].isGoingToRemove = false;
            this._children[i].cleanGoingToRemoveFlags();
        }
    };
    /**
     * Clean is-going-to-replace flags from tree nodes.
     */
    ColumnView.prototype.cleanGoingToReplaceFlags = function () {
        for (var i = 0; i < this._children.length; i++) {
            this._children[i]._isGoingToReplace = false;
            this._children[i].cleanGoingToReplaceFlags();
        }
    };
    ColumnView.prototype.getUsedCategoryPathIds = function () {
        var pathIds = [];
        if (this.element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
            pathIds.push(this.element.categoryElementDto.categoryPathHolderId);
        }
        for (var i = 0; i < this.children.length; i++) {
            var branchPathIds = this.children[i].getUsedCategoryPathIds();
            branchPathIds.forEach(function (pathId) {
                pathIds.push(pathId);
            });
        }
        return pathIds;
    };
    /**
     * Store calculated data
     * @param {string} key    calculated data key
     * @param value    calculated data value
     */
    ColumnView.prototype.setCalculatedValue = function (key, value) {
        this._calculatedBranchIndexesAfterOrBeforeChange.set(key, value);
    };
    /**
     * Get calculated data's value by key
     * @param {string} key    calculated data key
     * @returns {any} calculated data value
     */
    ColumnView.prototype.getCalculatedValue = function (key) {
        return this._calculatedBranchIndexesAfterOrBeforeChange.get(key);
    };
    /**
     * Remove calculated data from map
     * @param {string} key    calculated data key
     */
    ColumnView.prototype.removeCalculatedValue = function (key) {
        this._calculatedBranchIndexesAfterOrBeforeChange.delete(key);
    };
    return ColumnView;
}());
exports.ColumnView = ColumnView;
//# sourceMappingURL=column-view.model.js.map